import Icon from "common/components/icons";
import OptionsMenu from "pages/chat/components/option-menu";
import {
  Action,
  Actions,
  actionStyles,
  Avatar,
  AvatarWrapper,
  BackButton,
  Container,
  Name,
  ProfileTrigger,
  ProfileWrapper,
  Subtitle,
} from "./styles";

type HeaderProps = {
  onSearchClick: () => void;
  onProfileClick: () => void;
  title: string;
  image: string;
  subTitle: string;
  onBack?: () => void;
  showBack?: boolean;
};

export default function Header(props: HeaderProps) {
  const { title, subTitle, image, onProfileClick, onSearchClick, onBack, showBack } = props;
  const isGroupAvatar = Boolean(image && image.includes("group.png"));

  return (
    <Container>
      {showBack && (
        <BackButton onClick={onBack} aria-label="Back">
          <Icon id="back" className="icon" />
        </BackButton>
      )}
      <ProfileTrigger onClick={onProfileClick} type="button">
        <AvatarWrapper>
          <Avatar src={image} className={isGroupAvatar ? "avatar--group" : undefined} />
        </AvatarWrapper>
        <ProfileWrapper>
          <Name>{title}</Name>
          {subTitle && <Subtitle>{subTitle}</Subtitle>}
        </ProfileWrapper>
      </ProfileTrigger>
      <Actions>
        <Action onClick={onSearchClick}>
          <Icon id="search" className="icon search-icon" />
        </Action>
        <OptionsMenu
          styles={actionStyles}
          ariaLabel="Menu"
          iconId="menu"
          iconClassName="icon"
          options={[
            "Contact Info",
            "Select Messages",
            "Mute notifications",
            "Clear messages",
            "Delete chat",
          ]}
        />
      </Actions>
    </Container>
  );
}
